import Component from './InstagramInstantwinAnalyticsPublic.vue'
export default Component
